import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Button from 'components/Button/Button';
import Loader from 'components/Loader/Loader';
import Panel from 'components/Panel/Panel';

import useApi from 'utils/api';
import { useAuth } from 'utils/auth';

import styles from './styles.scss';

function YooAuth() {
    const api = useApi();
    const auth = useAuth();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = React.useState(true);
    const [error, setError] = React.useState(null);

    function goToSettings() {
        navigate('/settings');
    }

    React.useEffect(() => {
        const code = searchParams.get('code');
        const terminalId = searchParams.get('state');
        const companyId = auth?.company.id;

        api.postConfirmationToken(companyId, terminalId, {
            confirmation_token: code,
        })
            .then((data) => {
                console.log(data);
            })
            .catch((error) => {
                const { msg } = error;
                setError(msg);

                console.error(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <Panel
            contentStyles={{
                background: '#F4F4F6',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            fill={true}
        >
            <div className={styles.wrapper}>
                {isLoading && (
                    <div className={styles.processing}>
                        <Loader dark={true} />
                        <p className={styles.description}>Проверяем доступ к Вашему магазину в ЮКасса...</p>
                    </div>
                )}

                {!isLoading && !error && (
                    <div className={styles.done}>
                        <h2 className={styles.title}>Аккаунт ЮКассы привязан</h2>
                        <p className={styles.description}>
                            Теперь вы можете закончить настройку вашего терминала и начать принимать платежи.
                        </p>
                        <Button onClick={goToSettings} text="Перейти в настройки" level="secondary" />
                    </div>
                )}

                {!isLoading && error && (
                    <div className={styles.done}>
                        <h2 className={styles.title}>Не удалось привязать ЮКасса</h2>
                        <p className={styles.description}>Что-то пошло не так при проверки токена авторизации.</p>
                        <pre className={styles.error}>{error}</pre>
                    </div>
                )}
            </div>
        </Panel>
    );
}

export default YooAuth;
